/**
 * This file respects https://github.com/redux-utilities/flux-standard-action
 */

export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const AUTH_USER_SUCCESS = 'AUTH_USER_SUCCESS';
export const AUTH_USER_FAILURE = 'AUTH_USER_FAILURE';

export const AUTH_SET_POLICIES = 'AUTH_SET_POLICIES';

/** TWIST */
export const LOCALSTORAGE_REFRESH_TOKEN_KEY = 'dmx.refresh_token';
